"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 401.8 400.8",
    width: "100%",
    height: "100%",
    children: (0, jsx_runtime_1.jsxs)("g", {
      children: [(0, jsx_runtime_1.jsx)("path", {
        fill: "currentColor",
        d: "M280.2,64.2h-35.1v-3.3c0-6.3-5.1-11.4-11.4-11.4h-6.8v-4.8c0-3.7-3-6.8-6.8-6.8h-38.4c-3.7,0-6.8,3-6.8,6.8\n\t\tv4.8h-6.8c-6.3,0-11.4,5.1-11.4,11.4v3.3h-35.1C98.7,64.2,80,82.8,80,105.8v216.7c0,22.9,18.6,41.6,41.6,41.6h158.5\n\t\tc22.9,0,41.6-18.6,41.6-41.6V105.8C321.8,82.9,303.1,64.2,280.2,64.2z M201,47.3c5.5,0,9.9,4.4,9.9,9.9s-4.4,9.9-9.9,9.9\n\t\ts-9.9-4.4-9.9-9.9C191,51.7,195.5,47.3,201,47.3z M297.8,322.5c0,9.7-7.9,17.6-17.6,17.6H121.7c-9.7,0-17.6-7.9-17.6-17.6V105.8\n\t\tc0-9.7,7.9-17.6,17.6-17.6h35.1v11.3c0,6.3,5.1,11.4,11.4,11.4h65.4c6.3,0,11.4-5.1,11.4-11.4V88.2h35.1c9.7,0,17.6,7.9,17.6,17.6\n\t\tv216.7H297.8z"
      }), (0, jsx_runtime_1.jsx)("path", {
        fill: "currentColor",
        d: "M264,149.4h-72.2c-3.2,0-5.8,2.6-5.8,5.8v1.4c0,3.2,2.6,5.8,5.8,5.8H264c3.2,0,5.8-2.6,5.8-5.8v-1.4\n\t\tC269.9,152.1,267.2,149.4,264,149.4z"
      }), (0, jsx_runtime_1.jsx)("path", {
        fill: "currentColor",
        d: "M264,196h-72.2c-3.2,0-5.8,2.6-5.8,5.8v1.4c0,3.2,2.6,5.8,5.8,5.8H264c3.2,0,5.8-2.6,5.8-5.8v-1.4\n\t\tC269.9,198.6,267.2,196,264,196z"
      }), (0, jsx_runtime_1.jsx)("path", {
        fill: "currentColor",
        d: "M264,242.5h-72.2c-3.2,0-5.8,2.6-5.8,5.8v1.4c0,3.2,2.6,5.8,5.8,5.8H264c3.2,0,5.8-2.6,5.8-5.8v-1.4\n\t\tC269.9,245.1,267.2,242.5,264,242.5z"
      }), (0, jsx_runtime_1.jsx)("path", {
        fill: "currentColor",
        d: "M264,289h-72.2c-3.2,0-5.8,2.6-5.8,5.8v1.4c0,3.2,2.6,5.8,5.8,5.8H264c3.2,0,5.8-2.6,5.8-5.8v-1.4\n\t\tC269.9,291.6,267.2,289,264,289z"
      }), (0, jsx_runtime_1.jsx)("circle", {
        fill: "currentColor",
        cx: "142.6",
        cy: "156",
        r: "10.6"
      }), (0, jsx_runtime_1.jsx)("circle", {
        fill: "currentColor",
        cx: "142.6",
        cy: "202.5",
        r: "10.6"
      }), (0, jsx_runtime_1.jsx)("circle", {
        fill: "currentColor",
        cx: "142.6",
        cy: "249",
        r: "10.6"
      }), (0, jsx_runtime_1.jsx)("circle", {
        fill: "currentColor",
        cx: "142.6",
        cy: "295.6",
        r: "10.6"
      })]
    })
  });
};

exports.default = Icon;